// @ts-nocheck
export const fathomEventsAvailable = {
  "embedded-video-button-play": "Embedded video button play: Click",
  "register-event": "Event - Register: Click",
  "watch-event-on-demand": "Event - Watch on demand: Click",
  "hero-promo-button-click": "Hero Promo Buttons: Click",
  "sign-up-newsletter-news": "Newsletter Sign up - News: Click",
  "sign-up-newsletter-form": "Newsletter Sign up - Form: Click",
  "outbound-link-click": "Outbound Link: Custom Click",
} as const;

type fathomEventsKeys = keyof typeof fathomEventsAvailable;

export type FathomEvent = (typeof fathomEventsAvailable)[fathomEventsKeys];

export type FathomAnalyticsProps = {
  eventName: FathomEvent;
  /** an object with custom properties for the event */
  props?: Record<string, string>;
};

/**
 * Simple utility to set a fathom data analytics event
 * @param {DataAnalyticsProps}  dataAnalytics - A object with the event name a props to set
 */
export const fathomTrack = (dataAnalytics: DataAnalyticsProps) => {
  if (typeof window.fathom !== `undefined`) {
    window.fathom.trackEvent(dataAnalytics.eventName, {
      _value: JSON.stringify(dataAnalytics.props),
    });
  }
  return true;
};

/**
 * Utility to detect if a URL is external link
 * @param {linkUrl}  string - A string url
 * @returns {boolean} True or false
 */
export const isOutboundLink = (linkUrl) => {
  const link = new URL(linkUrl);
  return link && link.href && link.host && link.host !== window.location.host;
};

export function isFathomEvent(data: unknown): data is FathomAnalyticsProps {
  return data && typeof data.eventName === "string";
}
